"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentErrorMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _warning = _interopRequireDefault(require("../../../assets/svg/warning.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PaymentErrorMessage = exports.PaymentErrorMessage = function PaymentErrorMessage(_ref) {
  var paymentError = _ref.paymentError,
    errorMessageRef = _ref.errorMessageRef;
  if (!paymentError) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "payment-message",
    className: "mt-5 py-5 px-5 bg-error-50 text-black rounded-md",
    ref: errorMessageRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold leading-tight flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: _warning["default"],
    className: "inline mr-1"
  }), "Payment unsuccessful: ", paymentError), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-5"
  }, "Please try again or", " ", /*#__PURE__*/_react["default"].createElement("a", {
    className: "underline hover:no-underline same-host-redirect",
    href: "mailto:boost@tomocredit.com"
  }, "contact support.")));
};